<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Delete {{ selectedSensor.serialNumber }}?
      </div>
      <button
        class="ac-close-button"
        @click="toggleModal(true, 'edit-sensor-details', selectedSensor)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div
        v-if="timepointData"
        class="iot-data-loss-warning"
      >
        <span class="data-warn-txt">Warning: </span>
        Deleting could potentially result in the loss of this sensor's IOT data.
      </div>
      <div class="replace-instead-text">
        Did you want to
        <button
          class="replace-instead-btn"
          @click="toggleModal(true, 'replace-sensor', selectedSensor)"
        >
          replace
        </button>
        this sensor instead?
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-button"
        @click="removeSensor"
      >
        Delete
      </button>
    </div>
    <ProcessOverlay
      :show="processing"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'DeleteSensorWarning',
  components: {
    ProcessOverlay,
  },
  mixins: [customerDetailMixin],
  props: {
    toggleModal: Function,
  },
  data() {
    return {
      sensorDetail: {},
      timepointData: {},
      processing: false,
    };
  },
  async mounted() {
    this.timepointData = await this.$store.dispatch('getLatestTimepointData');
  },
  methods: {
    async removeSensor() {
      this.processing = true;
      try {
        await this.$store.dispatch('removeSensor');
        this.toggleModal(false);
      } catch (err) {
        console.error(err);
      }
      this.processing = false;
    },
  },
};
</script>

<style lang="scss">

.iot-data-loss-warning {
  font-size: 1rem;

  .data-warn-txt {
    color: $TOMATO100;
    font-size: 1rem;
    font-weight: 600;
  }
}

.replace-instead-text {
  font-size: 1rem;
  margin-top: 10px;

  .replace-instead-btn {
    color: $NBLUE110;
    font-size: 1rem;
    font-weight: 600;
  }
}
</style>
